var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTabs',{attrs:{"tabs":_vm.steps,"activeTab":_vm.activeTab,"breadcrumbMode":true,"compact":_vm.compact,"numbered":""}})}
var staticRenderFns = []

export { render, staticRenderFns }